module.exports = __webpack_public_path__ + "media/images/gallery/constellations/triangulum/tri_gc-23bea4327a14f53a24882c218d5130a4.gif";